<div #visualObjectContainer *ngIf="confDoubleValue">
  <div class="visual-object-margin">
    <text-box [view]="viewModel"
              [errors]="errors"
              type="number"
              (onValueChange)="onValueChange($event)"
              (onReadOnly)="onReadOnly($event)"
              (onDisabled)="onDisallowed($event)"
              (onHelpClick)="onHelpClick($event)"></text-box>
  </div>
</div>